import React from "react"
import AdvancedTimingImage from "../../../../../components/staticQuery/platform/automation/AdvancedTiming"
import P from "../../../../../components/typography/P"
import ClockGraphic from "../../../../../images/platform/automation/clock.svg"

const DescriptionText = () => (
  <>
    <P>
      Timing is everything. Send the right email or text at the wrong time and
      it will be ignored. Wait too long before sending critical information to a
      prospect who requested it, and they’ll go to a competitor.
    </P>
    <P>
      MindMe offers multiple advanced timing options to help you increase
      engagement and sales, and to make sure each Contact only receives your
      Sequence when you want them to!
    </P>
  </>
)

const targetPreciselyData = {
  titleIcon: ClockGraphic,
  title: "Advanced Timing",
  description: <DescriptionText />,
  graphic: <AdvancedTimingImage />,
  // imageLeft: false,
  textLong: false,
  benefits: [
    {
      benefitName: "Run on Specific Days",
    },
    {
      benefitName: "Run at Specific Times",
    },
    { benefitName: "Delay by Time or Date" },
    { benefitName: "Intelligent Wait options" },
    { benefitName: "Send Once or Repeat" },
  ],
}

export default targetPreciselyData
